import type { ReactNode } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import type { IconName } from '@hotjar/hotsauce';
import {
  Button,
  CloseAction,
  Icon,
  tokens,
  bannerStyles,
  baseNotificationStyles,
  closeActionStyles,
} from '@hotjar/hotsauce';

const S = {
  StyledNotification: styled.div`
    ${baseNotificationStyles.styles}
    ${bannerStyles('info')}
    background-color: ${tokens.color.bg_info};
    align-items: center;
  `,
  NotificationLabel: styled.span`
    flex-grow: 1;
    ${tokens.truncateText()}
  `,
  ActionsWrapper: styled.div`
    display: flex;
    padding: 0 ${tokens.spacer.x0pt5};
  `,
  Action: styled(Button)`
    margin: 0 ${tokens.spacer.x0pt5};
  `,
};

type ActionProps = {
  labelText: string;
  handleClick: () => void;
};

export type Props = {
  children: ReactNode;
  primaryAction?: ActionProps;
  secondaryAction?: ActionProps;
  onDismiss?: () => void;
  icon?: IconName;
};

export const UpsellBanner = ({
  children,
  primaryAction,
  secondaryAction,
  onDismiss,
  icon = 'crown',
}: Props): JSX.Element => {
  return (
    <S.StyledNotification>
      <Icon
        icon={icon}
        size="m"
        css={css`
          margin-right: ${tokens.spacer.x2};
          flex-shrink: 0;
        `}
      />
      <S.NotificationLabel>{children}</S.NotificationLabel>
      <S.ActionsWrapper>
        {secondaryAction && (
          <S.Action kind="ghost" size="s" onClick={secondaryAction.handleClick}>
            {secondaryAction.labelText}
          </S.Action>
        )}
        {primaryAction && (
          <S.Action kind="secondary" size="s" onClick={primaryAction.handleClick}>
            {primaryAction.labelText}
          </S.Action>
        )}
      </S.ActionsWrapper>
      {onDismiss && (
        <CloseAction
          onClick={onDismiss}
          description="Close upsell banner"
          css={closeActionStyles}
        />
      )}
    </S.StyledNotification>
  );
};
